<template>
  <div class="pr-side-popup-root">
    <SidePopup
      title=""
      v-on:close="onClose"
      :loading="loading"
      routeback="/fornecedor/comercial/programa-recompensa"
      :closeOnOutsideClick="!loading"
    >
      <template v-slot:title>
        <div class="pr-popup-title">
          <div class="pr-title-text">
            <h3 class="pr-title-main"># {{ displayClientName }}</h3>
          </div>
        </div>
      </template>

      <div v-if="error" class="pr-error">
        {{ error }}
      </div>

      <div v-else-if="detail" class="pr-body">
        <p class="pr-title-sub">
          <span class="pr-title-sub-lead">DETALHES DO CUPOM</span>
          <span v-if="detail && detail.coupon_code" class="pr-title-sub-code">
            · # {{ detail.coupon_code }}
          </span>
        </p>

        <v-divider class="mb-4" />

        <div class="pr-summary-grid">
          <div class="pr-card pr-card-status">
            <div class="pr-card-label">Status</div>
            <div class="pr-card-value pr-status-row">
              <span class="pr-status-dot" :class="statusDotClass" />
              <span>{{ statusLabel }}</span>
            </div>
          </div>
          <div class="pr-card pr-card-value-highlight">
            <div class="pr-card-label pr-card-label-accent">Valor do cupom</div>
            <div class="pr-card-value-big">
              {{ formatMoney(detail.coupon_value) }}
            </div>
          </div>
        </div>

        <div class="pr-summary-grid pr-summary-grid--3 mt-4">
          <div class="pr-card pr-card-plain">
            <div class="pr-card-label">Pontos utilizados</div>
            <div class="pr-card-value">
              {{ formatNumber(detail.points_used) }}
            </div>
          </div>
          <div class="pr-card pr-card-plain">
            <div class="pr-card-label">Data de expiração</div>
            <div class="pr-card-value">
              {{ formatDateTime(detail.expiration_date) }}
            </div>
          </div>
          <div class="pr-card pr-card-plain">
            <div class="pr-card-label">Data de utilização</div>
            <div class="pr-card-value">
              {{ formatDateTime(detail.usage_date) }}
            </div>
          </div>
        </div>

        <div class="pr-section mt-6">
          <div class="pr-section-heading">
            <v-icon small color="grey darken-1" class="mr-1"
              >fas fa-bolt</v-icon
            >
            <span>Regra aplicada</span>
          </div>
          <div class="pr-card pr-card-rule">
            <p v-if="metaRegra" class="pr-rule-text">Regra: {{ metaRegra }}</p>
            <p v-else class="pr-muted">
              Nenhuma regra informada nos metadados.
            </p>
            <small v-if="metaSetores.length" class="pr-muted">
              <template v-if="metaSetores.length === 1">
                Este cupom é válido para a categoria
                <strong>{{ metaSetores[0] }}</strong
                >.
              </template>
              <template v-else>
                Este cupom é válido para as categorias
                <strong>{{ metaSetores.join(", ") }}</strong
                >.
              </template>
            </small>
            <small v-else class="pr-muted">
              Este cupom é válido para todas as categorias elegíveis no momento
              do resgate.
            </small>
          </div>
        </div>

        <div class="pr-section mt-6">
          <div class="pr-section-heading">
            <v-icon small color="grey darken-1" class="mr-1"
              >fas fa-history</v-icon
            >
            <span>Histórico de acúmulo</span>
          </div>
          <div v-if="metaPedidos.length" class="pr-hist-list">
            <div
              v-for="(p, idx) in metaPedidos"
              :key="idx"
              class="pr-card pr-hist-item"
            >
              <div class="pr-hist-icon">
                <v-icon small color="green darken-1">fas fa-chart-line</v-icon>
              </div>
              <div class="pr-hist-main">
                <div class="pr-hist-id">#{{ p.pedido }}</div>
                <div class="pr-hist-date">{{ p.data_pedido }}</div>
              </div>
            </div>
          </div>
          <div v-else class="pr-card pr-card-plain pr-muted">
            Nenhum pedido vinculado no histórico de acúmulo.
          </div>
        </div>

        <div class="pr-section mt-6">
          <div class="pr-section-heading">
            <v-icon small color="grey darken-1" class="mr-1"
              >fas fa-info-circle</v-icon
            >
            <span>Outras informações</span>
          </div>
          <div class="pr-card pr-card-plain pr-extra-grid">
            <div>
              <span class="pr-muted">Código do cupom</span><br /><strong>{{
                detail.coupon_code || "—"
              }}</strong>
            </div>
            <div>
              <span class="pr-muted">Criado em</span><br /><strong>{{
                formatDateTime(detail.created_at)
              }}</strong>
            </div>
            <div>
              <span class="pr-muted">Atualizado em</span><br /><strong>{{
                formatDateTime(detail.updated_at)
              }}</strong>
            </div>
          </div>
        </div>
      </div>
    </SidePopup>
  </div>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import ApiWeb from "@/service/api-web";
import { mapGetters } from "vuex";
import * as moment from "moment";

export default {
  name: "ProgramaRecompensaDetalhe",
  components: { SidePopup },
  data: () => ({
    loading: true,
    error: "",
    detail: null
  }),
  computed: {
    ...mapGetters(["getFornecedorId"]),
    idcupom() {
      return this.$route.params.idcupom;
    },
    displayClientName() {
      const raw = (this.detail && this.detail.client_name) || "Cliente";
      return String(raw).toUpperCase();
    },
    statusLabel() {
      const s = this.detail && this.detail.status;
      if (s === "DISPONIVEL") return "Disponível";
      if (s === "UTILIZADO") return "Utilizado";
      if (s === "VENCIDO") return "Vencido";
      return s || "—";
    },
    statusDotClass() {
      const s = this.detail && this.detail.status;
      if (s === "DISPONIVEL") return "is-disponivel";
      if (s === "UTILIZADO") return "is-utilizado";
      if (s === "VENCIDO") return "is-vencido";
      return "";
    },
    parsedMetadata() {
      const raw = this.detail && this.detail.metadadosJson;
      if (raw == null || raw === "") {
        return {};
      }
      if (typeof raw === "object") {
        return raw;
      }
      try {
        return JSON.parse(String(raw));
      } catch {
        return {};
      }
    },
    metaRegra() {
      const r = this.parsedMetadata.regra;
      return r != null ? String(r) : "";
    },
    metaPedidos() {
      const arr = this.parsedMetadata.pedidos;
      return Array.isArray(arr) ? arr : [];
    },
    metaSetores() {
      const arr = this.parsedMetadata.setores;
      if (!Array.isArray(arr)) {
        return [];
      }
      return arr.map(x => String(x == null ? "" : x).trim()).filter(Boolean);
    }
  },
  watch: {
    idcupom: {
      immediate: true,
      handler() {
        this.load();
      }
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    load() {
      this.loading = true;
      this.error = "";
      this.detail = null;
      const fid = this.getFornecedorId;
      const id = this.idcupom;
      if (!fid || !id) {
        this.loading = false;
        this.error = "Dados insuficientes para carregar o cupom.";
        return;
      }
      ApiWeb.api
        .get(`/api/v4/programa-recompensa/cupom/${fid}/${id}`)
        .then(res => {
          this.detail = res.data;
        })
        .catch(err => {
          const msg =
            (err.response && err.response.data && err.response.data.err) ||
            err.message ||
            "Não foi possível carregar o cupom.";
          this.error =
            typeof msg === "string" ? msg : "Erro ao carregar o cupom.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatMoney(v) {
      if (v == null || v === "") {
        return "—";
      }
      const n = parseFloat(String(v).replace(",", "."));
      if (Number.isNaN(n)) {
        return v;
      }
      return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatNumber(v) {
      if (v == null || v === "") {
        return "—";
      }
      return String(v);
    },
    formatDateTime(v) {
      if (v == null || v === "") {
        return "—";
      }
      return moment(v).isValid()
        ? moment(v).format("DD/MM/YYYY HH:mm")
        : String(v);
    }
  }
};
</script>

<style lang="scss" scoped>
/*
 * O SidePopup usa position:absolute em .container-popup-side; sem um ancestral em tela cheia,
 * ele ancora ao router-view (área da lista) e o painel “desliza” do canto errado.
 * Fix: raiz fixa na viewport + filho preenchendo a altura.
 */
.pr-side-popup-root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  z-index: 1001;
  overflow: hidden;
}

.pr-side-popup-root ::v-deep .container-popup-side {
  min-height: 100%;
  height: 100%;
}

/* Largura do painel à direita em telas grandes (teto evita painel enorme em monitores largos) */
.pr-side-popup-root ::v-deep .section-container {
  @media (min-width: 1264px) {
    width: 35% !important;
    max-width: 560px !important;
    flex-shrink: 0;
  }
}

.pr-popup-title {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-right: 8px;
}

.pr-title-main {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
  text-transform: uppercase;
}

.pr-title-sub {
  margin: 8px 0 0;
  font-size: 1.125rem;
  line-height: 1.45;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
}

.theme--dark .pr-title-sub {
  color: rgba(255, 255, 255, 0.75);
}

.pr-title-sub-lead {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
}

.pr-title-sub-code {
  font-weight: 600;
  text-transform: none;
}

.pr-error {
  color: #c62828;
  padding: 16px;
}

.pr-body {
  padding-bottom: 24px;
}

.pr-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pr-summary-grid--3 {
  grid-template-columns: repeat(3, 1fr);
}

.pr-card {
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
}

.theme--dark .pr-card {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.12);
}

.pr-card-plain {
  background: #fafafa;
}

.theme--dark .pr-card-plain {
  background: #2a2a2a;
}

.pr-card-value-highlight {
  background: #e8f4fd;
  border-color: #90caf9;
}

.theme--dark .pr-card-value-highlight {
  background: rgba(33, 150, 243, 0.12);
  border-color: rgba(100, 181, 246, 0.4);
}

.pr-card-label {
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 8px;
}

.theme--dark .pr-card-label {
  color: rgba(255, 255, 255, 0.5);
}

.pr-card-label-accent {
  color: #1565c0;
}

.theme--dark .pr-card-label-accent {
  color: #90caf9;
}

.pr-card-value {
  font-size: 0.95rem;
  font-weight: 600;
}

.pr-card-value-big {
  font-size: 1.5rem;
  font-weight: 700;
  color: #5e35b1;
}

.theme--dark .pr-card-value-big {
  color: #b39ddb;
}

.pr-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pr-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.pr-status-dot.is-disponivel {
  background: #43a047;
}

.pr-status-dot.is-utilizado {
  background: #fb8c00;
}

.pr-status-dot.is-vencido {
  background: #78909c;
}

.pr-section-heading {
  display: flex;
  align-items: center;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 10px;
}

.theme--dark .pr-section-heading {
  color: rgba(255, 255, 255, 0.5);
}

.pr-card-rule {
  min-height: 56px;
}

.pr-rule-text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.45;
}

.pr-muted {
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.9rem;
}

.theme--dark .pr-muted {
  color: rgba(255, 255, 255, 0.5);
}

.pr-hist-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pr-hist-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pr-hist-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme--dark .pr-hist-icon {
  background: rgba(76, 175, 80, 0.15);
}

.pr-hist-main {
  flex: 1;
}

.pr-hist-id {
  font-weight: 600;
  font-size: 0.95rem;
}

.pr-hist-date {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.45);
}

.theme--dark .pr-hist-date {
  color: rgba(255, 255, 255, 0.5);
}

.pr-extra-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 20px;
}
</style>
